import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { norwalkConfig } from "./data";

export default function NorwalkPage() {
  return <CityPageTemplate config={norwalkConfig} />;
}